export const DEFAULT_PDF_MIME_TYPE = "application/pdf";
export const DEFAULT_ACCEPT_TYPE = ".pdf";
export const DEFAULT_MAX_FILE = 50;
export const DEFAULT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export type ValidationIssue = {
  code: "type" | "size" | "count";
  message: string;
  fileName?: string;
  fileSize?: number;
};

export type Constraints = {
  maxFiles?: number;           // ex: 50
  maxFileSizeBytes?: number;   // ex: 10 * 1024 * 1024
  acceptMime?: string[];       // ex: ["application/pdf"]
  acceptExt?: string[];        // ex: [".pdf"]
};

export type Props = {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
  onClear?: () => void;
  appendOnSelect?: boolean;
  accept?: string;
  footer?: React.ReactNode;
  constraints?: Constraints;
  onValidationError?: (issues: ValidationIssue[]) => void;
};

export const DEFAULT_CONSTRAINTS: Constraints = {
  maxFiles: DEFAULT_MAX_FILE,
  maxFileSizeBytes: DEFAULT_MAX_FILE_SIZE_BYTES,
  acceptMime: [DEFAULT_PDF_MIME_TYPE],
  acceptExt: [DEFAULT_ACCEPT_TYPE],
};

export const buildAcceptFromConstraints = (c: Constraints) => {
  const parts = [
    ...(c.acceptMime ?? []),
    ...(c.acceptExt ?? []),
  ];
  return parts.join(",");
};